// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"289":"2d8169e7","557":"414505c8","674":"ca782da4"}[chunkId] + ".chunk.css";
};